/* globals YT */
import EventEmitter from 'events';
import MicroModal from 'micromodal';
import { backfaceFixed } from './backfaceFixed';

export default class Modal extends EventEmitter {
  constructor() {
    super();
    window.addEventListener('DOMContentLoaded', () => {
      MicroModal.init({
        // onShow: modal => console.info(`${modal.id} is shown`), // [1]
        onShow: modal => {
          backfaceFixed(true);
          document.documentElement.classList.add('is-showModal');
          // player.loadVideoById('bHQqvYy5KYo');
        }, // [1]
        onClose: modal => {
          backfaceFixed(false);
          document.documentElement.classList.remove('is-showModal');
          // this.emit('close');
        }, // [2]
        // openTrigger: 'data-custom-open', // [3]
        // closeTrigger: 'data-custom-close', // [4]
        // openClass: 'is-open', // [5]
        // disableScroll: true, // [6]
        // disableFocus: false, // [7]
        awaitOpenAnimation: true, // [8]
        awaitCloseAnimation: true, // [9]
        debugMode: true, // [10]
      });
    });
  }
}
